import React, { useState, useEffect, useRef } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';

const cor = '#B51013';

export default function BuscaGlobal() {
  const [texto, setTexto] = useState('');
  const [resultados, setResultados] = useState({ colaboradores: [], cursos: [] });
  const [aberto, setAberto] = useState(false);
  const [buscando, setBuscando] = useState(false);
  const navigate = useNavigate();
  const inputRef = useRef();
  const containerRef = useRef();
  const timeoutRef = useRef();

  useEffect(() => {
    const handleClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setAberto(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    if (texto.length < 2) { setResultados({ colaboradores: [], cursos: [] }); setBuscando(false); return; }

    setBuscando(true);
    timeoutRef.current = setTimeout(async () => {
      try {
        const termo = texto.toLowerCase();

        const [colabSnap, cursosSnap] = await Promise.all([
          getDocs(collection(db, 'colaboradores')),
          getDocs(collection(db, 'cursos')),
        ]);

        const colaboradores = colabSnap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .filter(c => c.nome?.toLowerCase().includes(termo) || c.email?.toLowerCase().includes(termo) || c.funcao?.toLowerCase().includes(termo))
          .slice(0, 5);

        const cursos = cursosSnap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .filter(c => c.ativo !== false && c.nome?.toLowerCase().includes(termo))
          .slice(0, 5);

        setResultados({ colaboradores, cursos });
      } catch {}
      setBuscando(false);
    }, 350);
  }, [texto]);

  const totalResultados = resultados.colaboradores.length + resultados.cursos.length;

  const navegar = (path) => {
    navigate(path);
    setTexto('');
    setAberto(false);
  };

  return (
    <div ref={containerRef} style={{ position: 'relative', flex: 1, maxWidth: '360px' }}>
      <div style={{ position: 'relative' }}>
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#aaa', pointerEvents: 'none' }}>
          <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        <input
          ref={inputRef}
          value={texto}
          onChange={e => { setTexto(e.target.value); setAberto(true); }}
          placeholder="Buscar colaboradores, cursos..."
          style={{
            width: '100%', paddingLeft: '32px', paddingRight: texto ? '28px' : '10px',
            padding: '7px 10px 7px 32px',
            background: '#f5f5f5', border: '1px solid #e0e0e0', borderRadius: '8px',
            fontSize: '12px', outline: 'none', boxSizing: 'border-box',
            transition: 'border-color 0.15s',
          }}
          onFocus={e => { e.target.style.borderColor = cor; setAberto(true); }}
          onBlur={e => { e.target.style.borderColor = '#e0e0e0'; }}
        />
        {texto && (
          <button onClick={() => { setTexto(''); setAberto(false); }} style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: '14px', padding: '0', lineHeight: 1 }}>✕</button>
        )}
      </div>

      {/* Dropdown de resultados */}
      {aberto && texto.length >= 2 && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0,
          background: '#fff', borderRadius: '10px', border: '1px solid #e5e5e5',
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 500,
          overflow: 'hidden',
        }}>
          {buscando ? (
            <div style={{ padding: '16px', textAlign: 'center', fontSize: '12px', color: '#aaa' }}>Buscando...</div>
          ) : totalResultados === 0 ? (
            <div style={{ padding: '16px', textAlign: 'center', fontSize: '12px', color: '#aaa' }}>
              Nenhum resultado para "{texto}"
            </div>
          ) : (
            <>
              {resultados.colaboradores.length > 0 && (
                <div>
                  <div style={{ padding: '8px 14px 4px', fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '0.8px' }}>COLABORADORES</div>
                  {resultados.colaboradores.map(c => (
                    <div key={c.id} onClick={() => navegar(`/colaboradores/${c.id}`)} style={{ padding: '9px 14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', background: 'transparent' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f9f9f9'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: cor, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '600', color: '#fff', flexShrink: 0 }}>
                        {(c.nome || '?').split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: '12px', fontWeight: '500', color: '#1a1a1a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.nome}</div>
                        <div style={{ fontSize: '10px', color: '#888' }}>{c.funcao || c.email}</div>
                      </div>
                      <span style={{ fontSize: '10px', padding: '1px 6px', borderRadius: '5px', background: '#f0f0f0', color: '#888', flexShrink: 0 }}>N{c.nivel || 1}</span>
                    </div>
                  ))}
                </div>
              )}

              {resultados.cursos.length > 0 && (
                <div style={{ borderTop: resultados.colaboradores.length > 0 ? '1px solid #f0f0f0' : 'none' }}>
                  <div style={{ padding: '8px 14px 4px', fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '0.8px' }}>CURSOS</div>
                  {resultados.cursos.map(c => (
                    <div key={c.id} onClick={() => navegar(`/treinamento/${encodeURIComponent(c.nome)}`)} style={{ padding: '9px 14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', background: 'transparent' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f9f9f9'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <div style={{ width: '28px', height: '28px', borderRadius: '7px', background: '#FCEBEB', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="2" y="2" width="12" height="12" rx="2" stroke={cor} strokeWidth="1.3" opacity=".6"/><path d="M5 6h6M5 9h4" stroke={cor} strokeWidth="1.2" strokeLinecap="round"/></svg>
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: '12px', fontWeight: '500', color: '#1a1a1a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.nome}</div>
                        <div style={{ fontSize: '10px', color: '#888' }}>{c.duracao} · {c.formato}</div>
                      </div>
                      <span style={{ fontSize: '10px', fontWeight: '600', color: cor, flexShrink: 0 }}>+{c.pts} pts</span>
                    </div>
                  ))}
                </div>
              )}

              <div style={{ padding: '8px 14px', borderTop: '1px solid #f0f0f0', textAlign: 'center' }}>
                <span onClick={() => { navegar('/colaboradores'); }} style={{ fontSize: '11px', color: cor, cursor: 'pointer', fontWeight: '500' }}>
                  Ver todos os resultados →
                </span>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
